module.exports = __webpack_public_path__ + "img/biaozhunhua.07828145.jpg";